<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command" :status="status"
                 ref="dialog_form" @onSubmit="onSubmit">


    <template #default="{status}">

      <div v-if="form.scheduleId > 0">

        <t-input fixed v-model="enterprise" :label="accountModule === 'estate' ? 'Imóvel' : 'Empreendimento'"/>

        <t-input class="mt-2" v-model="form.issueDate" date date-now label="Data Inspecionado" required/>

        <t-input-code-label class="mt-2" v-if="relationAccessSubValidation('sub-checklist-change-inspector')" inspector
                            :status="status"
                            :command="command"
                            required
                            v-model="form.inspectorId"/>


      </div>

      <div v-else>

        <t-msg info>Inclusão de inspeção sem vínculo de agenda, caso desejar iniciar a inclusão por uma agenda acesse:
          <b-link :to="{name:'checklist-schedule'}">Agenda</b-link>
        </t-msg>

        <t-input-code-label environment
                            @change="getResumeEnvironment"
                            v-if="form.enableSingleEnvironment"
                            :status="status"
                            :command="command"
                            required
                            :add-error="error.environmentId"
                            v-model="form.environmentId"/>

        <div v-else>

          <t-input-code-label enterprise
                              enable-import-model
                              @onResume="getModelsByEnterpriseId"
                              :status="status"
                              :command="command"
                              required
                              :add-error="error.enterpriseId"
                              v-model="form.enterpriseId"/>

          <t-input select v-show="form.enterpriseId > 0" :options="typeChecklistOptions"
                   v-model="form.typeChecklistId" required
                   label="Modelo de Inspeção"/>

        </div>

        <!--      <b-form-checkbox v-model="form.enableSingleEnvironment" switch>
                <small>Inspeção somente para um ambiente específico?</small>
                <t-help title="Marque, caso desejar realizar um checklist somente para 1(um) ambiente."/>
              </b-form-checkbox>-->

        <t-input class="mt-2" v-model="form.issueDate" date date-now label="Data Realizado" required/>

        <t-input-code-label class="mt-2" v-if="relationAccessSubValidation('sub-checklist-change-inspector')" inspector
                            :status="status"
                            :command="command"
                            required
                            v-model="form.inspectorId"/>

        <t-input-search v-if="form.enterpriseId > 0 && accountModule === 'estate'"
                        v-model="form.compareChecklistId"
                        :options="checklistOptions"
                        placeholder="Não comparar"
                        small="Somente inspeções finalizadas no mesmo local"
                        label="Comparar com inspeção de entrada" select/>


      </div>


    </template>

  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import ChecklistPlatformType from "@/model/types/modules/checklist/ChecklistPlatformType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ui from "@/assets/scripts/ui";
import EnvironmentService from "@/services/modules/place/Environment.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import checklistService from "@/services/modules/checklist/Checklist.service";


export default {
  name: "ChecklistDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      ChecklistPlatformType,
      id: "modal-checklist",
      title: "Inclusão de Inspeção",
      okText: "Incluir Inspeção",
      form: {
        typeChecklistId: 0,
        enterpriseId: 0,
        inspectorId: 0,
        enableSingleEnvironment: false,
        environmentId: 0, /*Usado somente quando enableSingleEnvironment = true*/
        scheduleId: 0,/*Usado somente quando vir com origem em alguma agenda especifica*/
        initialLat: 0.0,
        initialLng: 0.0,
        platformOrigin: 0,
        compareChecklistId: 0,
        mobileDevice: {
          systemType: "",
          systemVersion: "",
          device: "",
          internetType: ""
        },
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        environmentId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      typeChecklistOptions: [],
      checklistOptions: [],
      enterprise: "",
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    schedule: {}
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.accountModule = ui.getAccountModule()

      //Limpa os campos
      this.resetModal()

      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.platformOrigin = ChecklistPlatformType.type.WEB


      if (this.schedule !== null && this.schedule !== undefined) {

        if (this.schedule.scheduleId !== null && this.schedule.scheduleId !== undefined) {

          this.form.scheduleId = this.schedule.scheduleId
          this.form.typeChecklistId = this.schedule.typeChecklistId
          this.form.enterpriseId = this.schedule.enterpriseId
          this.enterprise = this.schedule.enterprise

        }

      }

      await crudGeneral.getAssemble('checklist', 'list', '')
          .then(response => {

            this.userAuth = response.data;
            this.form.inspectorId = this.getRenderRule('inspector-by-user')


          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          });


      await ui.getDevice().then((device) => {

        //Insere informações mesmo não sendo um mobile, somente para controle
        this.form.mobileDevice.systemType = device.platform
        this.form.mobileDevice.device = device.appCodeName
        this.form.mobileDevice.systemVersion = device.userAgent

      })

      /*REMOVIDO EM 23/04/2026 PARA TESTES DO LEAD CLIENTE - PORTUGAL*/
      /*/!*Deixar por último, pois trava a execução até o usuário interagir com a caixa de dialogo do navegador*!/
      await ui.getPosition()
          .then((position) => {
            this.form.initialLat = position.latitude
            this.form.initialLng = position.longitude
          })*/

    },

    async onSubmit() {

      //Validações específicas da tela
      this.status = "sending"

      await this.setInsertDialog("checklist", (item) => {

        this.itemInserted.value = item.checklistNumber
        this.itemInserted.text = ''

        this.successInsert()

      })

    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async getChecklistByEnterprise() {

      //Limpa o checklist
      this.form.checklistId = 0

      let params = new URLSearchParams()
      params.append("enterpriseId", this.form.enterpriseId)
      params.append("status", 1)
      params.append("sorted", "issueDate desc,checklistNumber desc")
      params.append("statusChecklist", StatusChecklistType.type.FINISHED)

      await checklistService.selectList(params).then((list) => {
        this.checklistOptions = list
      }).catch(error => this.responseError(error))

    },

    async getResumeEnvironment(environmentId) {

      await EnvironmentService.getResume('id', environmentId)
          .then(resume => {
            this.form.enterpriseId = resume.enterpriseId
            this.enterprise = resume.enterprise
          })
    },

    async getModelsByEnterpriseId(resume) {

      if (this.form.enterpriseId > 0) {

        this.form.typeChecklistId = resume.preferentialTypeChecklistId

        await TypeChecklistModelService.getModelsByEnterpriseId(this.form.enterpriseId).then((list) => {
          this.typeChecklistOptions = list
        }).catch(error => this.responseError(error))


        await this.getChecklistByEnterprise()

      }

    }
    //--------------------------------------------------------------------------------------


  },
  watch: {
    noOptionAdd() {
      this.form.name = this.noOptionAdd
    }
  }
}
</script>
